import * as React from 'react';
import { Flex } from 'src/components/Flex/Flex';
import styled from 'styled-components';
import { Color, FileTypes, FlexPosition } from '../Globals/Globals';
import { Pill } from '../Pill/Pill';
import { Link } from 'react-router-dom';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ICardProps {
  cardType: 'solution' | 'file';
  businessLines?: string[];
  imageHtml?: string;
  fileId?: string;
  fileIcon?: IconProp;
  iconColor?: string;
  fileType?: FileTypes;
  description: string;
  url: string;
  solutionId: string;
  parseSolutionImageHtml?(html: string): Promise<string>;
  fetchFileThumbnailInBase64?(id: string): Promise<string>;
}

interface ICardState {
  parsedImageHtml: string;
  base64Thumbnail: string;
  loading: boolean;
}

const ImageCardWrapper = styled(Link)`
  display: flex;
  padding: 10px;
  height: 300px;
  width: 250px;
  min-width: 250px;
  text-decoration: none;
  flex-direction: column;
`;

const Image = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  & img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
`;

const ImageWrapper = styled(Flex)`
  background: ${Color.grey300};
  margin: 10px;
  min-height: 175px;
  max-height: 175px;
`;

const CardText = styled.div`
  color: ${Color.darkBlue};
  font-weight: 600;
  width: 100%;
  text-decoration: none;
  overflow-wrap: break-word;
`;

const CardIcon = styled(FontAwesomeIcon)`
  max-height: 200px;
  min-width: 100%;
  font-size: 3em;
  align-self: center;
  margin-bottom: 3px;
`;

const FileTypeText = styled.div`
  font-weight: 600;
  text-transform: capitalize;
  text-align: center;
`;

export class ImageCard extends React.Component<ICardProps, ICardState> {
  constructor(props: ICardProps) {
    super(props);

    this.state = {
      parsedImageHtml: '',
      base64Thumbnail: '',
      loading: true
    };
  }

  public componentDidMount() {
    switch (this.props.cardType) {
      case 'solution':
        this.handleSolutionThumbnailLoad();
        break;
      case 'file':
        this.handleFileThumbnailLoad();
        break;
    }
  }

  public handleSolutionThumbnailLoad() {
    if (
      this.props.imageHtml &&
      this.props.parseSolutionImageHtml &&
      this.props.imageHtml.length > 0
    ) {
      this.props
        .parseSolutionImageHtml(this.props.imageHtml)
        .then(parsedImageHtml => this.setState({ parsedImageHtml, loading: false }));
    } else {
      this.setState({ parsedImageHtml: 'No preview', loading: false });
    }
  }

  public handleFileThumbnailLoad() {
    if (this.props.fileType !== FileTypes.LINK) {
      if (this.props.fileId && this.props.fetchFileThumbnailInBase64) {
        this.props.fetchFileThumbnailInBase64(this.props.fileId).then(base64Thumbnail => {
          this.setState({ base64Thumbnail: base64Thumbnail.slice(1, -1), loading: false });
        });
      }
    } else {
      this.setState({ loading: false });
    }
  }

  public renderImageThumbnail() {
    switch (this.props.cardType) {
      case 'solution':
        return <Image dangerouslySetInnerHTML={{ __html: this.state.parsedImageHtml }} />;
      case 'file':
        switch (this.props.fileType) {
          case FileTypes.LINK:
            return (
              <Flex alignHorizontal={FlexPosition.center} alignVertical={FlexPosition.center}>
                <FileTypeText>
                  <CardIcon
                    icon={this.props.fileIcon ? this.props.fileIcon : 'file'}
                    color={this.props.iconColor ? this.props.iconColor : 'black'}
                  />
                  {this.props.fileType && (
                    <div style={{ color: this.props.iconColor }}>{this.props.fileType}</div>
                  )}
                </FileTypeText>
              </Flex>
            );
          default:
            return (
              <Image>
                <img src={`data:image/png;base64, ${this.state.base64Thumbnail}`} />
              </Image>
            );
        }
    }
  }

  public render() {
    return (
      <ImageCardWrapper to={this.props.url}>
        <ImageWrapper flexSize={4}>
          {!this.state.loading && this.renderImageThumbnail()}
        </ImageWrapper>
        <Flex flexSize={1} style={{ margin: '5px 10px' }}>
          <CardText>{this.props.description}</CardText>
        </Flex>
        <Flex flexSize={1} style={{ margin: '5px 10px', flexWrap: 'wrap' }}>
          {this.props.businessLines &&
            this.props.businessLines.map((text: string, i: number) => {
              return <Pill key={i}>{text}</Pill>;
            })}
        </Flex>
      </ImageCardWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageCard/ImageCard.tsx